// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon[data-v-02dc8f96]{fill:transparent;stroke:#0a234a}.icon.--no-stroke[data-v-02dc8f96]{stroke:transparent}", ""]);
// Exports
module.exports = exports;
